if (!customElements.get('stockist-locator')) {
  class StockistLocator extends HTMLElement {
    constructor() {
      super();
      this.started = false;
      this.load = this.load.bind(this);
    }

    connectedCallback() {
      this.addEventListener('pointerenter', this.load, { once: true, passive: true });
      this.addEventListener('focusin', this.load, { once: true });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '400px 0px' });
        this.observer.observe(this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    load() {
      if (this.started) return;
      this.started = true;
      this.observer?.disconnect();

      if (!window.__shopSanteStockistPromise) {
        window.__shopSanteStockistPromise = new Promise((resolve, reject) => {
          const existing = document.querySelector('script[data-shop-sante-stockist]');
          if (existing?.dataset.loaded === 'true') {
            resolve();
            return;
          }

          const script = existing || document.createElement('script');
          script.src = 'https://stockist.co/embed/v1/widget.min.js';
          script.async = true;
          script.dataset.shopSanteStockist = '';
          script.addEventListener('load', () => {
            script.dataset.loaded = 'true';
            resolve();
          }, { once: true });
          script.addEventListener('error', reject, { once: true });
          if (!existing) document.head.appendChild(script);
        });
      }

      window.__shopSanteStockistPromise.catch(() => {
        const widget = this.querySelector('[data-stockist-widget-tag]');
        if (widget) widget.textContent = this.dataset.error || '';
        this.classList.add('stockist-locator--error');
      });
    }
  }

  customElements.define('stockist-locator', StockistLocator);
}
